/**
 * Where a link goes when it goes nowhere: the path within this same app, or
 * `null` for anything that leaves it.
 *
 * The page's own origin is the only thing the design system knows about where
 * it is running, so that is what an address is held against. A relative address
 * is ours by definition. Anything without an origin of its own — `mailto:`,
 * `tel:` — leaves, because following it is not a page change.
 */
export function sameOriginPath(href: string | null | undefined): string | null {
  if (!href) {
    return null;
  }

  let url: URL;

  try {
    url = new URL(href, window.location.href);
  } catch {
    return null;
  }

  if (url.origin !== window.location.origin) {
    return null;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
